import { z } from "zod";

// NOTE: Duplicated from packages/backend/src/errors/types.ts.
// Move to a shared package later.
export enum ErrorCodes {
  BAD_REQUEST = "BAD_REQUEST", // 400
  UNAUTHORIZED = "UNAUTHORIZED", // 401
  FORBIDDEN = "FORBIDDEN", // 403
  NOT_FOUND = "NOT_FOUND", // 404
  CONFLICT = "CONFLICT", // 409
  VALIDATION_ERROR = "VALIDATION_ERROR", // 422
  INTERNAL_ERROR = "INTERNAL_ERROR", // 500
}

export enum ErrorCodeMessage {
  BAD_REQUEST = "Bad Request", // 400
  UNAUTHORIZED = "Unauthorized", // 401
  FORBIDDEN = "Forbidden", // 403
  NOT_FOUND = "Resource Not Found", // 404
  CONFLICT = "Conflict", // 409
  VALIDATION_ERROR = "Validation failed", // 422
  INTERNAL_ERROR = "Internal Server Error", // 500
}

export const ErrorResponseSchema = z.object({
  status: z.number(),
  errorCode: z.string(),
  message: z.string(),
  cause: z.unknown().optional(),
});

export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;
